module.exports = "/_next/static/images/CollectDataTabs-1-xs@2x-4cd56ed2c6ac63eaba62ff034ef96e8c.png";